import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { BaseSelectionList } from '../base/base-selection-list.component';
import { UsersService } from './../../../../core/api/services/users.service';

@Component({
    selector: 'user-selection-list',
    templateUrl: './user-selection-list.component.html',
    standalone: false
})
export class UserSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input() type:
    | 'users'
    | 'listDescendant'
    | 'listForAccessOrganization'
    | 'usersListByOrganizationId' = 'users';

  constructor(protected currentService: UsersService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    if (!this.optionValue) this.optionValue = 'userGuid';
    this.optionTitle = 'optionTitle';
    this.sortKey = 'userGuid';

    if (!this.input_label) this.input_label = 'common.users';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;

    switch (this.type) {
      // users
      case 'users':
        this.optionValue = 'userGuid';
        this.sortKey = 'userGuid';

        this.currentService
          .usersGetUsersList()
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;

      // listDescendant
      case 'listDescendant':
        this.optionValue = 'id';
        this.sortKey = 'id';

        this.currentService
          .usersGetUsersListDescendant()
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;

      // listForAccessOrganization
      case 'listForAccessOrganization':
        this.optionValue = 'userGuid';
        this.sortKey = 'userGuid';

        this.currentService
          .usersGetUsersListForAccessOrganization({ OrganizationId: +this.id })
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
      // listForAccessOrganization
      case 'usersListByOrganizationId':
        this.optionValue = 'id';
        this.sortKey = 'id';

        this.currentService
          .usersGetUsersListByOrganizationId({ organizationId: +this.id })
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.userName} (${item.firstName} ${item.lastName})`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
    }
  }
}
